import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { TableExt, TableInfo, themes, GridBox, GridColumnsSetup } from 'libs/ui';
import { useGridColumns } from 'libs/hooks';
import { getTableParams } from './grid.params';
import RfidForm from './forms/rfid-form';

export const RfidGrid = (props) => {
  const { count, entries, className, theme, getXlsAction, clientId, updateEntry } = props;
  const [showForm, setShowForm] = useState('');
  const [row, setRow] = useState({});

  const { t } = useTranslation();

  const rightEdit = user.haveRight('rfid.update');

  /**
   * add record
   */
  const addItemAction = () => {
    setRow({});
    setShowForm('addForm');
  };

  /**
   * edit record
   * @param {*} row
   */
  const editItemAction = (row) => {
    row.mean_id = row.rfid;
    setRow(row);
    setShowForm('editForm');
  };

  /**
   * close form
   * @returns
   */
  // const closeForm = () => setShowForm('');

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // actions
  const actions = [];
  if (user.haveRight('rfid.update')) {
    actions.push({
      isVisible: (row) => row.status !== 'blocked_by_client',
      getTitle: (row) => (row.is_blocked ? t('buttons.Разблокировать ') : t('buttons.Заблокировать ')),
      action: 'status', //() => setShowForm('statusForm'),
      actionType: 'rfid',
    });
  }

  if (!clientId) {
    if (user.haveRight('rfid.update') && user.haveRight('clients.view')) {
      actions.push({
        isVisible: (row) => !!row.client_id,
        title: t('buttons.Перейти в карточку клиента'),
        action: (row) => {
          window.location = '/card/client?id=' + row.client_id;
        },
      });
    }
  }

  // top actions
  // const rightAdd = user.haveRight('rfid.add');
  const topActions = [];
  if (!clientId) {
    // if (rightAdd && count) {
    //   topActions.push({
    //     title: t('buttons.Заменить тариф у RFID'),
    //     icon: 'fa-exchange',
    //     theme: themes.blue,
    //     action: replaceAction,
    //   });
    // }
    if (count) {
      getXlsAction(topActions);
    }
  } else {
    topActions.push({ title: t('buttons.Добавить'), icon: 'fa-plus', theme: themes.blue, action: addItemAction });
  }

  const tableParams = useMemo(() => getTableParams(t, clientId), [t, clientId]);
  const { getFields, fields: staticFields, ...restTableParams } = tableParams;
  const defaultFields = useMemo(() => (getFields ? getFields(props) : staticFields), [getFields, staticFields, props]);
  const { fields, columns, toggleColumn, reorderColumns, resetColumns } = useGridColumns('rfid', defaultFields);
  topActions.push({ cmp: <GridColumnsSetup key="columns-setup" columns={columns} onToggle={toggleColumn} onReorder={reorderColumns} onReset={resetColumns} /> });
  const initial =
    showForm === 'addForm'
      ? {
          // start_at: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          // end_at: moment().add(1, 'month').add(-1, 'day').format('YYYY-MM-DD 23:59:59'),
        }
      : { ...row };

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} actions={topActions} />

      <TableExt
        updateEntry={updateEntry}
        theme={theme}
        title="RFID"
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        onRowClick={rightEdit ? editItemAction : undefined}
        clientId={props.clientId}
        {...restTableParams}
        fields={fields}
      />

      {(showForm === 'editForm' || showForm === 'addForm') && (
        <RfidForm
          type={showForm}
          close={() => setShowForm('')}
          clientId={props.clientId}
          id={row.id}
          meanId={row.mean_id}
          meanType={row.mean_type}
          refresh={props.refresh}
          initialValues={initial}
          tariffs={props.tariffs}
        />
      )}
    </GridBox>
  );
};
